/*
 * Photography for the /biljetter page.
 *
 * Served from the WordPress media library rather than bundled into the CRA build:
 * WordPress generates the responsive sizes and fronts them with its own cache, and the
 * bundle stays small. The jubileumsväska image already worked this way.
 *
 * Never point at the bare upload: those are the camera originals (up to 4000x6000,
 * 5 MB). Each photo lists the sizes WordPress generated, as [file suffix, width], and
 * the components hand them to the browser as a srcset. The suffixes come from
 * /wp-json/wp/v2/media; re-check them there if a photo is replaced.
 */

const UPLOADS = 'https://harmoniexpo.com/wp-content/uploads'

const photo = (path, aspect, variants) => ({
	// Width / height of the source, for sizing it inside a cover-cropped box.
	aspect,
	src: `${UPLOADS}/${path}-${variants[1][0]}.jpg`,
	srcSet: variants.map(([suffix, width]) => `${UPLOADS}/${path}-${suffix}.jpg ${width}w`).join(', '),
})

const PORTRAIT_2_3 = [
	['200x300', 200],
	['683x1024', 683],
	['1024x1536', 1024],
	['1365x2048', 1365],
	['scaled', 1707],
]

export const photos = {
	// Hero background.
	heroProgram: photo('2026/09/Besokare-tittar-i-programmet-Harmoni-Expo', 2 / 3, PORTRAIT_2_3),
	// The four square tiles under "Mer än en mässa, en upplevelse".
	moten: photo('2026/09/Moten-och-samtal-pa-Harmoni-Expo', 4 / 3, [
		['300x225', 300],
		['1024x768', 1024],
		['1536x1152', 1536],
	]),
	besokare: photo('2026/09/Besokare-pa-Harmoni-Expo', 3 / 4, [
		['225x300', 225],
		['768x1024', 768],
		['1152x1536', 1152],
	]),
	meditation: photo('2026/09/Meditation-i-jubilumstaltet-Harmoni-Expo', 2 / 3, PORTRAIT_2_3.slice(0, 3)),
	scenen: photo('2026/09/Scenen-gemenskap-pa-Harmoni-Expo', 3 / 4, [
		['225x300', 225],
		['768x1024', 768],
		['1152x1536', 1152],
	]),
}

export const jubileumsvaska = `${UPLOADS}/2026/01/harmoni_expo_jubileumsvaska.png`
